import "./index.scss";
import { TextProps } from "./types";
import { getTextAlignClassNames } from "utilities/commonPropTypes/textAlign";
import React, { Children } from "react";
import cn from "classnames";
import recursiveRender from "utilities/recursiveRender";

const Text = ({
  titleHeading,
  text,
  ctaList,
  textTheme,
  defaultTextAlign,
  smTextAlign,
  mdTextAlign,
  lgTextAlign,
  xlTextAlign,
  liveInspector,
}: TextProps) => {
  const textClasses = cn(
    "Text",
    "editorial",
    {
      [`Text--${textTheme}`]: textTheme,
    },
    getTextAlignClassNames({
      defaultTextAlign,
      smTextAlign,
      mdTextAlign,
      lgTextAlign,
      xlTextAlign,
    }),
  );

  return (
    <div className={textClasses} {...liveInspector?.text}>
      {titleHeading && <div className="Text__title">{titleHeading}</div>}
      <div className="Text__content">{text}</div>
      {Array.isArray(ctaList) && ctaList?.length > 0 && (
        <div className="Text__cta-list">
          {ctaList.map((cta) => {
            return (
              <div className="Text__cta-list__item" key={cta.id}>
                {recursiveRender({ cfComponent: cta })}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Text;
